import { reportModuleImportError } from '../utils/module-import';

const benefitsTables = document.querySelectorAll<HTMLElement>('.benefits-table-24');
const highlightsTables = document.querySelectorAll<HTMLElement>('.highlights-table-block');

if (benefitsTables.length || highlightsTables.length) {
  const breakpoints = [768, 1200];
  import(/* webpackChunkName: "tariffs-module" */ './tariffs-module')
    .then(({ initHighlightsTable, initBenefitsTable }) => {
      for (const highlightsTable of highlightsTables) {
        if (highlightsTable.querySelector('.clinic-highlight-block')) continue;
        initHighlightsTable(highlightsTable);
        breakpoints.forEach(breakpoint => {
          const mediaMatcher = window.matchMedia(`(min-width: ${breakpoint}px)`);
          mediaMatcher.addEventListener('change', () => initHighlightsTable(highlightsTable));
        });
      }
      for (const benefitsTable of benefitsTables) {
        initBenefitsTable(benefitsTable);
        window.addEventListener('orientationchange', () => {
          if (window.innerWidth < 1200) {
            initBenefitsTable(benefitsTable);
          }
        });
      }
    })
    .catch(error => reportModuleImportError(error, { chunk: 'tariffs-module' }));
}
